import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './i18n/de.json';
import en from './i18n/en.json';
import fr from './i18n/fr.json';
import it from './i18n/it.json';

const resources = {
  en: { translation: en },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: window.location.pathname.substring(1, 3),
    fallbackLng: 'de',
    interpolation: { escapeValue: false },
    debug: false
  });

export default i18n;
